/** @jsx jsx */
import { Box, Flex, jsx } from "theme-ui";
import React from "react";
import RockitLink from "../link/rockit-link";
import useGetNav from "./hooks/use-get-nav";
import { NavigationItem } from "./types";

export const NavFooter: React.FC = () => {
  const navItems: NavigationItem[] | undefined = useGetNav({
    location: "Footer",
  })?.navItems;

  return (
    <Flex
      pl={0}
      as="ul"
      color="white"
      sx={{
        textAlign: ["center", "left"],
        listStyleType: "none",
        width: "100%",
        flexDirection: ["column", "row"],

        justifyContent: ["center", "space-between"],
        alignItems: ["center", "flex-start"],
      }}
    >
      {navItems?.map((menuItem) => (
        <Box key={`${menuItem.label}-footer`} as="li">
          <RockitLink
            sx={{
              color: "white",
              fontSize: [3],
              lineHeight: ["48px", "1em"],
            }}
            to={menuItem.url || "/"}
          >
            {menuItem.label}
          </RockitLink>

          {menuItem.subNavigation && (
            <Box as="ul">
              {menuItem.subNavigation?.listItems.map((menuItem) => (
                <Box key={`${menuItem.title}-footer`} as="li">
                  <RockitLink
                    sx={{
                      color: "white",
                      fontSize: [2, 1],
                      lineHeight: ["48px", "1em"],
                    }}
                    to={menuItem.url || "/"}
                  >
                    {menuItem.title}
                  </RockitLink>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Flex>
  );
};
export default NavFooter;
